export default {
  publicOrigin: 'https://tilisy.enablebanking.com',
  publicSandboxOrigin: 'https://tilisy-sandbox.enablebanking.com',
  enablebankingOrigins: ['https://auth.enablebanking.com', 'https://tilisy.enablebanking.com', 'https://auth-sandbox.enablebanking.com', 'https://tilisy-sandbox.enablebanking.com'],
  // list of default public origins prod and sandbox
  enablebankingTermsUrl: 'https://auth.enablebanking.com/terms',
  baseLanguage: 'EN',
  countryLocales: {
    AT: 'DE',
    CZ: 'CS',
    DK: 'DA',
    DE: 'DE',
    EE: 'ET',
    ES: 'ES',
    FI: 'FI',
    FR: 'FR',
    IE: 'EN',
    IS: 'IS',
    IT: 'IT',
    LT: 'LT',
    LV: 'LV',
    NL: 'NL',
    NO: 'NO',
    PL: 'PL',
    SE: 'SV'
  }
}
